import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyD83neK98xPidzHEaoDhcGpd2R_JvgsPjY",
    authDomain: "lyricapp-e5e57.firebaseapp.com",
    projectId: "lyricapp-e5e57",
    storageBucket: "lyricapp-e5e57.appspot.com",
    messagingSenderId: "278999920412",
    appId: "1:278999920412:web:2da67a48872bfe08d7d4d9",
    measurementId: "G-FTQZF4Z828"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;